export function voucherCompanyPatcher(data) {
    return {
        __typename: 'VoucherCompanyData',
        billPayers: data.billPayers.map(b => ({
            ...b,
            __typename: 'VoucherCompanyBillPayer',
            shares: { ...b.shares, __typename: 'VoucherCompanyBillPayerShares' },
        })),
        children: data.children.map(c => ({ ...c, __typename: 'VoucherCompanyChild' })),
    };
}
